import React, { useEffect, useState } from "react";
import { axiosInstance } from "../../../../../config/axios";
import { APIURL } from "../../../../../configApi";
export default function (props) {
  const { filters, setFilters } = props;
  const [service_id, setServiceId] = useState("");
  const [groupe_id, setGroupeId] = useState(0);
  const [groupesService, setGroupesService] = useState([]);

  const [services, setServices] = useState([]);
  const [groupes, setGroupes] = useState([]);
  const [sgroupes, setSGroupes] = useState([]);
  const [all, setAll] = useState(true);

  const updateServiceList = (value) => {
    if (value != "0") {
      setAll(false);
      [...groupes].map((g) => {
        g.sub_groups.map((sg) => {
          if (sg.id == value) {
            setServices(sg.services);
          }
        });
      });

      //setGroupesService([...groupes.sub_groups.filter((g) => g.id == value)]);
    } else {
      setAll(true);
    }
  };

  const getGroupes = () => {
    axiosInstance
      .get(`${APIURL}/laboratory/groups`)
      .then((res) => {
        setGroupes(res.data.data.list);
        setGroupesService(res.data.data.list);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const updateService = (serviceId) => {
    setServiceId(serviceId);
    if (serviceId == 0) {
      setFilters({
        ...filters,
        service: 0,
      });
    } else {
    setFilters({
      ...filters,
      service: serviceId,
    });
  }
  };
  const updateGroupe = (groupeId) => {
    console.log("goupe id", groupeId);
    if (groupeId == 0) {
      setFilters({
        ...filters,
        groupe: 0,
        service: 0,
      });
    } else {
      setGroupeId(groupeId);
      setFilters({
        ...filters,
        groupe: groupeId,
        service: 0,
      });
    }
  };
  useEffect(() => {
    getGroupes();
  }, []);

  return (
    <>
      <div className="mt-2">
        <h4>Services </h4>
        <div className="d-flex mt-2 gap-2">
          <select
            className="form-control"
            value={groupe_id}
            onChange={(e) => {
              updateGroupe(e.target.value);
              updateServiceList(e.target.value);
            }}
          >
            <option value={"0"}>
              {" "}
              <strong> == Tous les sous groupes == </strong>{" "}
            </option>
            {groupes && groupes.length > 0
              ? groupes.map((g) => (
                  <optgroup label={g.name}>
                    {g.sub_groups.map((sg) => (
                      <option value={sg.id}>{sg.name}</option>
                    ))}
                  </optgroup>
                ))
              : ""}
          </select>

          <select
            className="form-control"
            value={service_id}
            onChange={(e) => {
              updateService(e.target.value);
            }}
          >
            {" "}
            <option value="0" >
              {" "}
              Choisir une service{" "}
            </option>
            {all
              ? groupesService && groupesService.length > 0
                ? groupesService.map((g) =>
                    g.sub_groups.map((sg) => (
                      <optgroup label={sg.name + ` ( ` + g.name + ` )`}>
                        {" "}
                        {sg.services.map((s) => (
                          <option value={s.id}>{s.name}</option>
                        ))}
                      </optgroup>
                    ))
                  )
                : ""
              : services.map((s) => <option value={s.id}>{s.name}</option>)}
          </select>
        </div>
      </div>
    </>
  );
}
